<template>
  <div>
    <div class="titleCap">
      <div class="size6 mb-2" style="color: #262626;font-weight: bold">
        <span>{{ info.expertName }}的信息详情</span>&nbsp;
      </div>
    </div>
    <a-tabs default-active-key="1">
      <a-tab-pane key="1" tab="基本信息">
        <table class="fx-form-view">
          <col width="120px"/>
          <col/>
          <col width="120px"/>
          <col/>
          <col width="120px"/>
          <col/>
          <tr>
            <th>姓名</th>
            <td>
              {{ info.expertName }}
            </td>
            <th>出生年月</th>
            <td>
              {{ info.birthdate }}
            </td>
            <th>性别</th>
            <td>
              {{ info.gender == '1' ? '男' : '女' }}
            </td>
          </tr>
          <tr>
            <th>民族</th>
            <td>
              {{ info.national }}
            </td>
            <th>身份证号</th>
            <td>
              {{ info.idCard }}
            </td>
            <th>是否在职</th>
            <td>
              {{ info.isIncumbency == '1' ? '是' : '否' }}
            </td>
          </tr>
          <tr>
            <th>工作电话</th>
            <td>
              {{ info.workPhone }}
            </td>
            <th>手机号码</th>
            <td>
              {{ info.mobilePhone }}
            </td>
            <th>是否从事相关领域工作满八年</th>
            <td>
              {{ info.isEightYear === '1' ? '是' : '否' }}
            </td>
          </tr>
          <tr>
            <th>住宅电话</th>
            <td>
              {{ info.homePhone }}
            </td>
            <th>电子邮箱</th>
            <td>
              {{ info.email }}
            </td>
            <th>回避单位</th>
            <td>
              {{ info.avoidUnit }}
            </td>
          </tr>
          <tr>
            <th>所学专业</th>
            <td>
              {{ info.studyProfession }}
            </td>
            <th>职务</th>
            <td>
              {{ info.position }}
            </td>
            <th>职称</th>
            <td>
              {{ info.professionaltitle }}
            </td>
          </tr>
          <tr>
            <th>从事专业</th>
            <td>
              {{ info.workProfession }}
            </td>
            <th>毕业学校</th>
            <td>
              {{ info.school }}
            </td>
            <th>最高学历</th>
            <td>
              {{ info.extras.educationName }}
            </td>
          </tr>
          <tr>
            <th>擅长专业</th>
            <td>
              {{ info.skilledProfession }}
            </td>
            <th>采购品目</th>
            <td colspan="3">
              {{ info.purchaseItem }}
            </td>
          </tr>
          <tr>
            <th>单位性质</th>
            <td>
              {{ info.extras.unitProperties }}
            </td>
            <th>工作单位全称</th>
            <td colspan="3">
              {{ info.unitName }}
            </td>
          </tr>
          <tr>
            <th>所在部门</th>
            <td>
              {{ info.inDept }}
            </td>
            <th>所在行政区域</th>
            <td>
              {{ info.extras.areaAddressText }}
            </td>
            <th>联系地址</th>
            <td colspan="3">
              {{ info.address }}
            </td>
          </tr>
         <!--  <tr>
            <th>参加技术团体情况</th>
            <td colspan="5">
              {{ info.technicalTeam }}
            </td>
          </tr> -->
          <tr v-if="info.stockOutReason">
            <th>出库原因</th>
            <td colspan="5">
              {{ info.stockOutReason }}
            </td>
          </tr>
          <tr>
            <th>专家标签</th>
            <td colspan="5">
              <a-tag
                  v-for="(it, index) in info.extras.tagInfos"
                  :key="it.id"
                  :title="it.tagDetail"
                  :color="it.tagColor">
                {{ it.tagName }}
              </a-tag>
              &nbsp;&nbsp;&nbsp;&nbsp;
              <a-space style="float: right" v-if="isAdmin">
                <a class="link_blue" type="primary" @click="doSet(info.id, info.extras.tagIds)">设置</a>
                <a-divider type="vertical"/>
                <a-popconfirm title="确认删除所有标签?" ok-text="是" cancel-text="否" @confirm="onDelete(info.id)">
                  <a class="link_blue">重置</a>
                </a-popconfirm>
              </a-space>
            </td>
          </tr>

          <tr>
            <th>备注</th>
            <td colspan="5">
              {{ info.remark }}
            </td>
          </tr>
        </table>
      </a-tab-pane>
      <a-tab-pane key="2" tab="附件信息">
        <table class="fx-form-view">
          <col width="320px"/>
          <col/>
          <tr>
            <th>身份证扫描件</th>
            <td>
              <upload-index :referId='info.id' configKey='expert.apply.idcard' :zip-title="info.name + '的相关附件'"/>
            </td>
          </tr>
          <tr>
            <th>学历证书/毕业证书</th>
            <td>
              <upload-index :referId='info.id' configKey='expert.apply.diploma' :zip-title="info.name + '的相关附件'"/>
            </td>
          </tr>
          <tr>
            <th>专业技术职称证书</th>
            <td>
              <upload-index :referId='info.id' configKey='expert.apply.technical'
                            :zip-title="info.name + '的相关附件'"/>
            </td>
          </tr>
          <tr>
            <th>职业资格证书等其他资料</th>
            <td>
              <upload-index :referId='info.id' configKey='expert.apply.professional'
                            :zip-title="info.name + '的相关附件'"/>
            </td>
          </tr>
        </table>
      </a-tab-pane>
      <a-tab-pane key="3" tab="拓展信息">
        <table class="fx-form-view">
          <col width="120px"/>
          <col/>
          <!-- <tr>
            <th>工作简历</th>
            <td v-html="info.jobResume"></td>
          </tr> -->
          <tr>
            <th>专业领域</th>
            <td v-html="info.academic"></td>
          </tr>
          <tr>
            <th>学术成果</th>
            <td v-html="info.majorResult"></td>
          </tr>
          <tr>
            <th>获得奖励</th>
            <td v-html="info.reward"></td>
          </tr>
        </table>
      </a-tab-pane>
      <a-tab-pane key="4" tab="工作记录">
        <expertFees-STable
            :expertId="info.id"
        />
      </a-tab-pane>
      <a-button type="primary" slot="tabBarExtraContent" @click="goToEdit()" v-if="fromType!=expertFromType.STOCK_OUT && fromType!=expertFromType.STOCK_IN">
        修改信息
      </a-button>
    </a-tabs>

    <tag-set-modal ref="tagSetModal" @success="onSetSuccess"/>

  </div>
</template>

<script>

import UploadIndex from '@/components/selector/UploadIndex'
import DictCascader from '@/components/dict/DictCascader'
import { ExpertFromType } from '@/epp/expertmain/expertInfo/utils/ExpertInfoUtil'
import expertFeesSTable from '@/epp/expertmain/expertFees/common/ExpertFeesSTable.vue'
import TagSetModal from '@/epp/expertmain/experttag/modal/TagSetModal'

export default {
  name: 'ExpertViewTable',
  components: {
    TagSetModal,
    UploadIndex,
    DictCascader,
    expertFeesSTable
  },
  props: {
    info: {
      type: Object,
      default: () => {
        return { extras: {} }
      }
    },
    fromType:{
      type: String,
      default: ExpertFromType.EXPERT_LIST
    }
  },
  data () {
    return {
      isAdmin: false,
      user: this.$ls.get('user'),
    }
  },
  computed: {
    expertFromType () {
      return ExpertFromType
    }
  },
  created () {
    this.isAdmin = (this.user.permissions['expert.info.manage'] || this.user.permissions['system.manage'])
  },
  methods: {
    onDelete (id) {
      this.$http.post('/api/1/expertmain/expert_tag/delTagExpert?expertId=' + id).then(resp => {
        this.delLoading = false
        if (resp.code !== 200) {
          this.$error({ content: '重置失败！' })
          return false
        }
        this.$message.success('重置成功')
        this.onSetSuccess(id)
      })
    },
    onSetSuccess () {
      this.$emit('success')
    },
    doSet (id, ids) {
      this.$refs.tagSetModal.onStartLoadData(id, ids)
    },
    goToEdit(){
      this.$router.push({ path: '/expertInfo/expertLoginEdit' })
    }
  }
}
</script>

<style></style>
